
export const root = {
    transitionDuration: '{transition.duration}'
};

export const panel = {
    borderWidth: '0',
    borderColor: '{content.border.color}'
};

export const header = {
    color: '{text.muted.color}',
    hoverColor: '{text.color}',
    activeColor: '{text.color}',
    activeHoverColor: '{text.color}',
    padding: '1.125rem',
    fontWeight: '700',
    borderRadius: '0',
    borderWidth: '0 1px 1px 1px',
    borderColor: '{content.border.color}',
    focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: 'inset {focus.ring.shadow}'
    },
    toggleIcon: {
        color: '{text.muted.color}',
        hoverColor: '{text.color}',
        activeColor: '{text.color}',
        activeHoverColor: '{text.color}'
    },
    first: {
        topBorderRadius: '{content.border.radius}',
        borderWidth: '1px'
    },
    last: {
        bottomBorderRadius: '{content.border.radius}',
        activeBottomBorderRadius: '0'
    }
};

export const content = {
    borderWidth: '0 1px 1px 1px',
    borderColor: '{content.border.color}',
    background: '{content.background}',
    color: '{text.color}',
    padding: '1.125rem'
};

export const colorScheme = {
    light: {
        header: {
            background: '{surface.50}',
            hoverBackground: '{surface.100}',
            activeBackground: '{surface.50}',
            activeHoverBackground: '{surface.100}'
        }
    },
    dark: {
        // Dark surface ramp is dark→light as the number rises (surface-50 = #24282F dark,
        // surface-800 = #9AA1AC light). Mirror the light scheme's structure with the dark
        // low-end tokens so headers stay dark — surface-100 is the theme's designated hover.
        header: {
            background: '{surface.50}',
            hoverBackground: '{surface.100}',
            activeBackground: '{surface.50}',
            activeHoverBackground: '{surface.100}'
        }
    }
};

export default {
    root,
    panel,
    header,
    content,
    colorScheme
};
